import React from 'react';
import { compose, pure } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import LinkIcon from '@material-ui/icons/Link';

const styles = {
  leftIcon: {
    padding: '0px 5px'
  }
};

const enhance = compose(pure);

const button = enhance(
  ({ classes, onClickAction, onClickParams, disabled = false }) => {
    return (
      <Button
        color="primary"
        onClick={() => onClickAction(onClickParams)}
        disabled={disabled}
      >
        <LinkIcon className={classes.leftIcon} />
        店舗紐付け
      </Button>
    );
  }
);

export default withStyles(styles)(button);
